import axios from 'axios';
import {
    LABRESULT_LIST_REQUEST, LABRESULT_LIST_SUCCESS, LABRESULT_LIST_FAIL,
    LABRESULT_LIST_BY_IDS_REQUEST, LABRESULT_LIST_BY_IDS_SUCCESS, LABRESULT_LIST_BY_IDS_FAIL,
    LABRESULT_DETAILS_REQUEST, LABRESULT_DETAILS_SUCCESS, LABRESULT_DETAILS_FAIL,
    LABRESULT_CREATE_REQUEST, LABRESULT_CREATE_SUCCESS, LABRESULT_CREATE_FAIL,
    LABRESULT_UPDATE_REQUEST, LABRESULT_UPDATE_SUCCESS, LABRESULT_UPDATE_FAIL,
    LABRESULT_DELETE_REQUEST, LABRESULT_DELETE_SUCCESS, LABRESULT_DELETE_FAIL,
    LABRESULT_DTO_REQUEST, LABRESULT_DTO_SUCCESS, LABRESULT_DTO_FAIL,
} from '../constants/labResultConstants';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/labresult';

export const listLabResults = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: LABRESULT_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listLabResultsByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getLabResultDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createLabResult = (labResultData) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            labResultData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateLabResult = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteLabResult = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: LABRESULT_DELETE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const loadLabResultDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: LABRESULT_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: LABRESULT_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: LABRESULT_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 